import React from 'react'
import CommonInput from '../../../../common/Resusable/CommonInput'
import RadioToggle from '../../../SearchPanel/RadioToggle'
import uploadIconBlack from '../../../../assets/images/uploadIconBlack.svg'

const SlrAdditionalDetailsSection = ({
	t,
	shippingDescription,
	setShippingDescription,
	hasAttachments,
	setHasAttachments,
	setAttachments,
	setAttachmentError,
	attachments,
	handleRemoveAttachment,
	isUploadingAttachments = false,
	getRootProps,
	getInputProps,
	attachmentError,
	airwayBillNumber,
	setAirwayBillNumber,
	isEditMode = false,
	renderEditDetails,
}) => {
	return (
		<div className='form-container slr-additional-form-container'>
			<div className='cargo-pieceschkbox-row'>
				<div className='form-group slr-remarks-input'>
					<label className='sub-head-label mb-2'>
						{t('BOOKING.SLR_BOOKING_REMARKS_PLACEHOLDER')}
					</label>
					<textarea
						className='form-control slr-remarks-textarea'
						value={shippingDescription}
						onChange={(e) => setShippingDescription(e.target.value)}
						rows={3}
					/>
				</div>
			</div>

			{isEditMode && typeof renderEditDetails === 'function'
				? renderEditDetails()
				: null}

			<div className='cargo-pieceschkbox-row position-relative'>
				<div className='form-group'>
					<label className='sub-head-label mb-2'>
						{t('BOOKING.SLR_HAS_ATTACHMENTS')}
					</label>
					<RadioToggle
						checkedArray={[hasAttachments === true, hasAttachments === false]}
						valueArray={['Yes', 'No']}
						labelArray={['COMMON.YES', 'COMMON.NO']}
						className='has-attachments-toggle'
						onChangeArray={[
							() => { if (!isUploadingAttachments) setHasAttachments(true) },
							() => {
								if (isUploadingAttachments) return
								setHasAttachments(false)
								setAttachments([])
								setAttachmentError('')
							},
						]}
					/>
				</div>
			</div>

			{hasAttachments && (
				<div className='cargo-pieceschkbox-row position-relative slr-file-upload'>
					<label className='sub-head-label mb-2'>
						{t('BOOKING.SLR_ATTACHMENTS')}
					</label>
					{attachments.length > 0 && (
						<div className='dg-upload-body w-100'>
							<ul className='dg-up-file-list'>
								{attachments.map((file, i) => (
									<li key={i} className='dg-up-file'>
										<div className='up-file-details'>
											{file.url ? (
												<a href={file.url} target='_blank' rel='noopener noreferrer' className='slr-attachment-link'>
													{file.fileName || file.name}
												</a>
											) : <span>{file.fileName || file.name}</span>}
										</div>
										<span
											className='up-file-delete'
											onClick={() => { if (!isUploadingAttachments) handleRemoveAttachment(i) }}
										>
											{t('COMMON.DELETE')}
										</span>
									</li>
								))}
							</ul>
						</div>
					)}
					<div className='file-upload-block'>
						<div className='upload-content-block' {...getRootProps()}>
							<input {...getInputProps()} />
							<img src={uploadIconBlack} alt='upload' title='upload' />
							<div className='upload-drop-label'>
								<label className='upload-label'>
									{t('COMMON.UPLOAD_CLICK')}
								</label>
								<label className='drop-label'>{t('COMMON.UPLOAD_DROP')}</label>
							</div>
							<label className='drop-label'>
								{t('COMMON.UPLOAD_TYPE_INFO')}
							</label>
						</div>
					</div>
					{attachmentError && (
						<span className='common-input-error'>
							{t(attachmentError, { ns: 'errors' })}
						</span>
					)}
				</div>
			)}

			<div className='cargo-pieceschkbox-row'>
				<div className='form-group slr-remarks-input'>
					<CommonInput
						type='text'
						label={t('BOOKING.SLR_AIRWAY_BILL_PLACEHOLDER')}
						value={airwayBillNumber}
						onChange={(e) => setAirwayBillNumber(e.target.value)}
					/>
				</div>
			</div>


		</div>
	)
}

export default SlrAdditionalDetailsSection
